const moduleState = {
  showOnlyOwnChangeOrders: true,
  searchQuery: '',
}

const getters = {
  showOnlyOwnChangeOrders: (state) => state.showOnlyOwnChangeOrders,
  searchQuery: (state) => state.searchQuery,
}

const mutations = {
  setFilterShowOnlyOwnChangeOrders(state, payload) {
    state.showOnlyOwnChangeOrders = payload
  },
  setFilterSearchQuery(state, payload) {
    state.searchQuery = payload
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  namespaced: true,
}
